import University from './Pages/University/University';
import Reset from './Pages/Reset/Reset';
import LearningArcade from './Pages/LearningArcade/LearningArcade';
import IB from './Pages/IB/IB';
import HardvardX from './Pages/HarvardX/HardvardX';
import ACT from './Pages/ACT/ACT';
import FLL from './Pages/FLL/FLL';
import PWebsite from './Pages/PWebsite/PWebsite';
import Sylems from './Pages/Sylems/Sylems';
import UC from './Pages/UC/UC';
import Kaedim from './Pages/Kaedim/Kaedim';
import CrystalAI from './Pages/CrystalAI/CrystalAI';
import PixelArt from './Pages/PixelArt/PixelArt';
import TheLibrary from './Pages/TheLibrary/TheLibrary';
import Symbiotic from './Pages/Symbiotic/Symbiotic';
import PirateSWGJ14 from './Pages/PirateSWGJ14/PirateSWGJ14';
import DelianAlliance from './Pages/DelianAlliance/DelianAlliance';

export const pages = {
  'University of Southampton': University,
  Reset,
  'Learning Arcade': LearningArcade,
  'IB Diploma': IB,
  HarvardX: HardvardX,
  ACT,
  FLL,
  'Am I Challenger Yet': UC,
  Vereselyum: Sylems,
  'Personal Website': PWebsite,
  Kaedim: Kaedim,
  CrystalAI,
  'Pixel Art Mastery': PixelArt,
  'The Library': TheLibrary,
  Symbiotic,
  'Pirate SW GJ 14': PirateSWGJ14,
  'Delian Alliance': DelianAlliance,

  // 'Recollections of a Drowned Mind': Recollections,
};
